var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('div',[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilter),expression:"showFilter"}]},[_c(_setup.Filters)],1),_c('section',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFilter),expression:"!showFilter"}]},[_c(_setup.CreateQuestion)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }